import { detalheBoleto, visualizarBoletoPdf, visualizarComprovante, visualizarResumoCobranca } from '@/views/14/RegrasDeNegocio14'
const preloadWidget = async (row, funcionalidade, authorization) => {
  const detalhe = await detalheBoleto(row.idTitulo, row.codigoTitulo, row.idRegistro)
  return createPayload(detalhe, funcionalidade, authorization)
}

function createPayload (detalhe, funcionalidade, authorization) {
  const payload = {
    'idFuncionalidade': funcionalidade.idFuncionalidade,
    'data': {
      ...detalhe
    },
    'configuracao': {
      'parametros': {},
      'metodoEnvio': []
    },
    'opcoesDeEnvio': []
  }
  if (funcionalidade.parametros.configuracoesDeWidgets.permiteEnvioChatWidget) {
    payload.configuracao.metodoEnvio.push({
      'tipo': {
        'id': 1,
        'descricao': 'Mensagem no chat'
      },
      'sincrono': true
    })
  }
  if (funcionalidade.parametros.configuracoesDeWidgets.permiteEnvioEmailWidget && funcionalidade.parametros.configuracoesDeWidgets.templateEnvioEmailWidget) {
    payload.configuracao.metodoEnvio.push({
      'tipo': {
        'id': 2,
        'descricao': 'E-mail'
      },
      'template': funcionalidade.parametros.configuracoesDeWidgets.templateEnvioEmailWidget,
      'sincrono': false
    })
  }
  if (funcionalidade.parametros.configuracoesDeWidgets.permiteEnvioWhatsappWidget && funcionalidade.parametros.configuracoesDeWidgets.templateEnvioWhatsappWidget) {
    payload.configuracao.metodoEnvio.push({
      'tipo': {
        'id': 3,
        'descricao': 'WhatsApp'
      },
      'template': funcionalidade.parametros.configuracoesDeWidgets.templateEnvioWhatsappWidget,
      'sincrono': false
    })
  }
  if (visualizarBoletoPdf(detalhe)) {
    payload.opcoesDeEnvio.push({
      'nome': funcionalidade.parametros.labelDoBotaoBoletoEmPdf,
      'nomeIntegracao': 'boletoPdf',
      'integracao': {
        'headers': {
          'Authorization': authorization
        },
        'parametros': {},
        'rota': {
          ...funcionalidade.rotas.boletoPdf
        },
        'payload': {
          'idTitulo': detalhe.idTitulo,
          'codigoTitulo': detalhe.codigoTitulo
        }
      },
      'data': {
        'tituloWidget': `${detalhe.descricao}-${detalhe.codigoTitulo}-${funcionalidade.parametros.labelDoBotaoBoletoEmPdf}`
      }
    })
  }
  if (visualizarResumoCobranca(detalhe)) {
    payload.opcoesDeEnvio.push({
      'nome': funcionalidade.parametros.labelDoBotaoResumoCobranca,
      'nomeIntegracao': 'resumoCobrancaPdf',
      'integracao': {
        'headers': {
          'Authorization': authorization
        },
        'parametros': {},
        'rota': {
          ...funcionalidade.rotas.resumoCobrancaPdf
        },
        'payload': {
          'idTitulo': detalhe.idTitulo,
          'codigoTitulo': detalhe.codigoTitulo
        }
      },
      'data': {
        'tituloWidget': `${detalhe.descricao}-${detalhe.codigoTitulo}-${funcionalidade.parametros.labelDoBotaoResumoCobranca}`
      }
    })
  }
  if (visualizarComprovante(detalhe)) {
    payload.opcoesDeEnvio.push({
      'nome': funcionalidade.parametros.labelDoBotaoComprovantePagamento,
      'nomeIntegracao': 'comprovantePagamentoPdf',
      'integracao': {
        'headers': {
          'Authorization': authorization
        },
        'parametros': {},
        'rota': {
          ...funcionalidade.rotas.comprovantePagamentoPdf
        },
        'payload': {
          'idTitulo': detalhe.idTitulo,
          'codigoTitulo': detalhe.codigoTitulo
        }
      },
      'data': {
        'tituloWidget': `${detalhe.descricao}-${detalhe.codigoTitulo}-${funcionalidade.parametros.labelDoBotaoComprovantePagamento}`
      }
    })
  }
  return payload
}
export { preloadWidget }
